import React, { useEffect } from 'react'
import DepositeRateContainer from '../containers/DepositeRate'
import Nav from '../components/nav/Nav';

const DepositeRate: React.FC= () => {


  useEffect(() => {
    document.title = 'Elite Community CU |  Deposite Rate';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "... DIVIDENDS WILL BE COMPOUNDED AND CREDITED TO ACCOUNTS EVERY QUARTER. Rates subject to change quarterly. Dividends paid Third Quarter, 2018 ...";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <DepositeRateContainer />
    </div>
  )
}

export default DepositeRate